import React from "react";
import { useRecoilValue } from "recoil";
import storeConfigAtom from "~/services/store-config/store-config.atom";
import { replaceClassNames } from "~/utils/converters";
import styles from "./TopHeader.module.scss"

type Props = {};

const TopHeader = (props: Props) => {
  const storeConfig = useRecoilValue(storeConfigAtom.store);
  return (
    <div>
      {storeConfig?.store_notice_enable && (
        <div
          dangerouslySetInnerHTML={{
            __html: replaceClassNames(storeConfig.store_notice_message, {
              Header: styles,
            }),
          }}
        />
      )}
    </div>
  );
};

export default TopHeader;
